import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import axios from "axios";
import MontlyCounterSaleSummaryModel from "../../../models/reports/monthlycountersalesummary_reports";
import { PDFExport } from "@progress/kendo-react-pdf";
import MonthWiseComparativeModel from "../../../models/masters/monthwisecomparative-model";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";

interface IMonthWiseComparativeReport {}

export const MonthWiseComparativeReport: React.FC = () => {
  const [reportMenu, setReportMenu] = useState<IMonthWiseComparativeReport[]>(
    []
  );
  const [fromDate, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );
  const [toDate, setToDate] = useState<Date>(new Date());
  const [MonthWiseComparativeList, setMonthWiseComparativeList] = useState<
    MonthWiseComparativeModel[]
  >([]);
  const exportExcel = useRef<ExcelExport | null>(null);
  const pdfExportRef = useRef<PDFExport | null>(null);

  const { data: companyDetails, isLoading: isCompanyLoading } =
    useGetCompanyDetails();
  const companyName = companyDetails?.[0]?.companyName || "Company Name";
  const hasRecords = MonthWiseComparativeList.length > 0;
  const exportToExcel = () => {
    if (!exportExcel.current) return;

    const options = exportExcel.current.workbookOptions();
    const sheet = options.sheets[0];

    const formattedFromDate = fromDate
      ? new Date(fromDate).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

    const formattedToDate = toDate
      ? new Date(toDate).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

    const headingWithDate = `MonthWise_Comparative - ${formattedFromDate} to ${formattedToDate}`;

    // Add a single merged heading row with the full string
    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    exportExcel.current.save(options);
  };

  const exportToPDF = () => {
    if (pdfExportRef.current) {
      pdfExportRef.current.save();
    }
  };

  useEffect(() => {}, [reportMenu]);

  const getMonthWiseComparativeList = async () => {
    try {
      // Format fromDate and toDate correctly
      const formattedFromDate = dayjs(fromDate).format("MM");
      const formattedFromYear = dayjs(fromDate).format("YYYY");
      const formattedToDate = dayjs(toDate).format("MM");
      const formattedToYear = dayjs(toDate).format("YYYY");

      // Validate that fromDate and toDate are not the same
      if (
        formattedFromDate >= formattedToDate &&
        formattedFromYear >= formattedToYear
      ) {
        alert("Please select toMonth bigger than fromMonth.");
        return; // Do not proceed if the dates are the same
      }

      // const getMonthWiseComparativeUrl = `${getEndPoint(
      //   API_END_POINT.REPORT
      // )}/api/AnalyseReport/GetMonthwiseComparision/${formattedFromDate}/${formattedFromYear}/${formattedToDate}/${formattedToYear}`;

      const response = await getDataWithToken<any>(
        `${getEndPoint(
          API_END_POINT.REPORT
        )}/api/AnalyseReport/GetMonthwiseComparision/${formattedFromDate}/${formattedFromYear}/${formattedToDate}/${formattedToYear}`
      );

      // const response = await axios.get(getMonthWiseComparativeUrl);
      const monthWiseComparative = response?.data?.result || [];
      console.log("monthWiseComparative", monthWiseComparative);
      setMonthWiseComparativeList(monthWiseComparative);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  let grid = (
    <Grid
      data={MonthWiseComparativeList}
      total={null}
      groupable={false}
      sortable={true}
      onDataStateChange={null}
      onExpandChange={null}
      expandField=""
      columnVirtualization={false}
      resizable={true}
    >
      <GridColumn
        title="S.No"
        cell={(props) => {
          const index = props.dataItem
            ? MonthWiseComparativeList.indexOf(props.dataItem) + 1
            : 0;
          return <td>{index}</td>;
        }}
      />
      <GridColumn 
       field="zone" 
       title="Zone" 
       columnMenu={null} />


      <GridColumn
        field="route"
        title="Route"
        columnMenu={null}
      />
      <GridColumn
        field="agent_Code"
        title="Agent Code"
        columnMenu={null}
      />
      <GridColumn
        field="agent"
        title="Agent"
        columnMenu={null}
      />
      <GridColumn
        field="lit1"
        title={`${formatDate(fromDate, "MMMM yyyy")} (Liter1)`}
        cell={(props) => (
          <td style={{ textAlign: "right" }}>
            {props.dataItem.lit1?.toFixed(2)}
          </td>
        )}
      />
      <GridColumn
        field="lit2"
        title={`${formatDate(toDate, "MMMM yyyy")} (Liter2)`}
        cell={(props) => (
          <td style={{ textAlign: "right" }}>
            {props.dataItem.lit2?.toFixed(2)}
          </td>
        )}
      />
      <GridColumn
        field="diffqty"
        title="Difference Quantity"
        cell={(props) => (
          <td style={{ textAlign: "right" }}>
            {props.dataItem.diffqty?.toFixed(2)}
          </td>
        )}
      />
      <GridNoRecords>
        <div className="mt-2" style={{ width: "100%", height: "500px" }}>
          <center>
            <h5>No data found</h5>
          </center>
        </div>
      </GridNoRecords>
    </Grid>
  );

  return (
    <>
      <div
        className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
        style={{ minHeight: "500px" }}
      >
        <div className="top-sec-align row">
          <center>
            <h4 className="text-normal title-web mb-0 report-title-color">
              Month Wise Comparative
            </h4>
          </center>
        </div>
        <div className="fade_rule"></div>
        <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
          <div className="d-flex">
            <div className="me-2">
              <label>Select From Month</label>
              <DatePicker
                showMonthYearPicker
                className="form-control ms-auto search-right-align calendarBg"
                selected={fromDate}
                dateFormat="MMMM yyyy" // Displays month as text (e.g., "January 2024")
                onChange={(date: Date) => {
                  setFromDate(date);
                }}
                placeholderText="Select Month & Year"
              />
            </div>
            <div className="me-2">
              <label>Select To Month</label>
              <DatePicker
                showMonthYearPicker
                className="form-control ms-auto search-right-align calendarBg"
                selected={toDate}
                dateFormat="MMMM yyyy" // Displays month as text (e.g., "January 2024")
                onChange={(date: Date) => {
                  setToDate(date); // Set toDate to the selected date
                }}
                placeholderText="Select Month & Year"
              />
            </div>
            <div>
              <label></label>
              <button
                className="btn-primary btn search-btns mt-4"
                onClick={() => {
                  getMonthWiseComparativeList();
                }}
                type="submit"
              >
                <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                  <path
                    id="Path_magnify"
                    data-name="Path / magnify"
                    d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                    transform="translate(-3 -3)"
                    fill="#fff"
                  />
                </svg>
              </button>
            </div>
            <div className="d-flex justify-content-end">
              <button
                title="Export Excel"
                className="export-button ms-2"
                onClick={exportToExcel}
                disabled={!hasRecords}
                style={{ marginTop: "23px", marginBottom: "2px" }}
              >
                Export to Excel
              </button>
              <button
                title="Export Excel"
                className="export-button ms-2"
                onClick={exportToPDF}
                disabled={!hasRecords}
                style={{ marginTop: "23px", marginBottom: "2px" }}
              >
                Export to PDF
              </button>
            </div>
          </div>
        </div>
        <div className="row col=12">
          <LoadingIndicator isLoading={false} />
          <PDFExport
            fileName={"MonthWise_Comparative.pdf"}
            ref={pdfExportRef}
            title="Date Wise Comparative"
          >
             <div style={{ padding: "10px", backgroundColor: "#fff" }}>
              {/* Company Name */}
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                  {companyDetails?.[0]?.companyName || "Company Name"}
                </span>
              </div>
              <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                  MonthWise_Comparative
                  {fromDate && toDate && (
                    <>
                      {" - "}
                      {new Date(fromDate).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                      })}{" "}
                      to{" "}
                      {new Date(toDate).toLocaleDateString("en-IN", {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                      })}
                    </>
                  )}
                </span>
              </div>
              {grid}
            </div>
            <ExcelExport
              fileName={"MonthWise_Comparative"}
              data={MonthWiseComparativeList}
              ref={exportExcel}
            >
              <ExcelExportColumn  
              field="zone" 
              title="Zone" />

              <ExcelExportColumn  
              field="route" 
              title=" Route" />

              <ExcelExportColumn
                field="agent_Code"
                title="Agent Code"
              />
              <ExcelExportColumn 
              field="agent" 
              title="Agent Name" />

              <ExcelExportColumn
                field="lit1"
                title={`${formatDate(fromDate, "MM-yyyy")} (  )`}

              />
              <ExcelExportColumn
                field="lit2"
                title={`${formatDate(toDate, "dd-MM-yyyy")} (Liter2)`}

              />
              <ExcelExportColumn
                field="diffqty"
                title="Difference Quantity"
              />
            </ExcelExport>
          </PDFExport>
        </div>
      </div>
    </>
  );
};
